import { render, staticRenderFns } from "./contactDr.vue?vue&type=template&id=0a7459c8&scoped=true"
import script from "./contactDr.vue?vue&type=script&lang=js"
export * from "./contactDr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7459c8",
  null
  
)

export default component.exports